export class GlobalConstants {
    static maxDecimalPlaces = 4;
    static defaultCurrencyDecimalPlaces = 2;
    static maxQuantity = 999999999;
    static minQuantity = 0.0001;
}
